import { wellsLegendFilterIdAtom } from "atoms";
import { useAtomValue } from "jotai";
import {
  selectIsAwaitingFilter,
  useFilterLandingBinStore
} from "stores/filterLandingBinStore";

import { EntityKind } from "models/entityKind";

/**
 * Whether the well legend's bins were grouped for another filter than the live one:
 * a saved filter still in flight, or a landed filter the map has not grouped yet.
 * Its rows wait meanwhile, or the live filter's ticks land on the other filter's bins.
 */
export function useIsLegendBehindFilter(
  entityKind: EntityKind,
  filterId: string
): boolean {
  const isAwaitingFilter = useFilterLandingBinStore(selectIsAwaitingFilter);
  const legendFilterId = useAtomValue(wellsLegendFilterIdAtom);
  return (
    entityKind === EntityKind.Well &&
    (isAwaitingFilter || (!!legendFilterId && legendFilterId !== filterId))
  );
}
